export default "__VITE_PUBLIC_ASSET__6af27f44__"